var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 35,
    viewBox: "0 0 82 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.1029 27.3754C79.9159 27.3754 81.3856 25.8882 81.3856 24.0537C81.3856 22.2191 79.9159 20.7319 78.1029 20.7319C76.29 20.7319 74.8203 22.2191 74.8203 24.0537C74.8203 25.8882 76.29 27.3754 78.1029 27.3754Z",
    fill: "#F9DF1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5835 10.3757C36.51 10.3757 39.8754 13.7197 39.8754 18.6108C39.8754 18.9391 39.8602 19.2519 39.8129 19.7819H29.0966C29.0966 21.3291 30.2083 22.2505 32.0768 22.2505C33.2189 22.2505 33.915 21.9069 35.0266 20.8128L39.6287 23.1258C38.1471 25.7671 35.1669 27.3759 31.7068 27.3759C26.4577 27.3759 22.457 23.6883 22.457 18.845C22.457 14.0018 26.4104 10.3757 31.5835 10.3757ZM29.2825 16.72H33.6058C33.4048 15.4395 32.6952 14.8446 31.4129 14.8446C30.0546 14.8446 29.2977 15.5165 29.2825 16.72Z",
    fill: "#203864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7969 26.8747V0H49.2202V26.8747H42.7969Z",
    fill: "#203864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8967 10.3757C67.3317 10.3757 71.5317 13.8753 71.5317 18.8758C71.5317 23.8763 67.3317 27.3759 61.8967 27.3759C56.4617 27.3759 52.2617 23.8763 52.2617 18.8758C52.2617 13.8753 56.4617 10.3757 61.8967 10.3757ZM61.8967 21.8761C63.4713 21.8761 64.7992 20.6572 64.7992 18.8758C64.7992 17.0944 63.4713 15.8755 61.8967 15.8755C60.3222 15.8755 58.9942 17.0944 58.9942 18.8758C58.9942 20.6572 60.3222 21.8761 61.8967 21.8761Z",
    fill: "#203864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.57812 35H8.95939L21.8686 10.8743H14.4873L1.57812 35Z",
    fill: "#203864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.8743H7.38127L11.0643 17.2648L7.54177 23.8467L0 10.8743Z",
    fill: "#F9DF1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.52344 23.8473L11.046 17.2654L14.8642 23.9567L11.2757 30.6617L7.52344 23.8473Z",
    fill: "#203864"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 35,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTop);
export default __webpack_public_path__ + "static/media/logo-top.6acf186b75f8d6828a8a10e162e3866c.svg";
export { ForwardRef as ReactComponent };